"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.templateType = exports.messageType = exports.dispositionType = exports.conversationType = exports.contactType = exports.campaignType = exports.arrayMultimedia = void 0;
var _propTypes = require("prop-types");
var _constants = require("./constants");
var templateType = exports.templateType = (0, _propTypes.shape)({
  title: _propTypes.string.isRequired,
  text: _propTypes.string.isRequired
});
var contactType = exports.contactType = (0, _propTypes.shape)({
  name: _propTypes.string,
  account: _propTypes.string,
  image: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.element])
});
var campaignType = exports.campaignType = (0, _propTypes.shape)({
  id: _propTypes.number.isRequired,
  name: _propTypes.string.isRequired,
  account: _propTypes.string,
  senderName: _propTypes.string,
  timeout: _propTypes.number.isRequired,
  timeoutWarning: _propTypes.number.isRequired,
  image: _propTypes.string
});
var messageType = exports.messageType = (0, _propTypes.shape)({
  id: _propTypes.number,
  origin: (0, _propTypes.oneOf)(Object.values(_constants.MSG_SOURCE)).isRequired,
  seen: _propTypes.bool,
  date: (0, _propTypes.instanceOf)(Date).isRequired,
  subject: _propTypes.string,
  content: _propTypes.string,
  media: (0, _propTypes.arrayOf)(_propTypes.string)
});
var conversationType = exports.conversationType = (0, _propTypes.shape)({
  id: _propTypes.number.isRequired,
  type: (0, _propTypes.oneOf)(Object.values(_constants.TABS)).isRequired,
  contact: contactType.isRequired,
  campaign: campaignType.isRequired,
  initialTime: (0, _propTypes.instanceOf)(Date).isRequired,
  templates: (0, _propTypes.arrayOf)(templateType),
  typing: _propTypes.bool,
  disabled: _propTypes.bool,
  messages: (0, _propTypes.arrayOf)(messageType)
});
var dispositionType = exports.dispositionType = (0, _propTypes.shape)({
  id: _propTypes.number.isRequired,
  text: _propTypes.string.isRequired
});
var arrayMultimedia = exports.arrayMultimedia = (0, _propTypes.shape)({
  url: _propTypes.string.isRequired,
  mediaType: _propTypes.string.isRequired
});


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/utils/types.js
// module id = 60
// module chunks = 0